import React, { useState, useRef } from 'react';
export const MediaFeatures = ({
  onCursorChange
}) => {
  const [activeTab, setActiveTab] = useState('publications');
  const [isTabChanging, setIsTabChanging] = useState(false);
  const contentRef = useRef(null);
  // Handle tab change with animation
  const handleTabChange = tab => {
    if (tab === activeTab) return;
    // Trigger animation
    setIsTabChanging(true);
    setTimeout(() => {
      setActiveTab(tab);
      setIsTabChanging(false);
    }, 300);
  };
  // Publications
  const publications = [{
    title: 'CARELESS PEOPLE',
    author: 'Sarah Williams',
    year: '2025',
    publisher: 'Hardcover',
    cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eDftUnBAFNRxWmHnVxD19Z/Image_3.jpg',
    description: 'A cautionary tale of power, greed, and lost idealism.',
    rating: '4.5/5 stars (7,899 ratings)',
    goodreads: '4.2 on Goodreads (59,946 ratings)',
    awards: '#1 New York Times Bestseller, Amazon Charts #10'
  }, {
    title: 'UNDERCURRENTS OF POWER',
    author: 'Kevin Dawson',
    year: '2018',
    publisher: 'Hardcover',
    cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1ernrv9U5TDQTUxUdP9T9E/1200x900wz.jpg',
    description: 'Aquatic Culture in the African Diaspora.',
    rating: '4.7/5 stars (27 ratings)',
    goodreads: '4.0 on Goodreads (42 ratings)',
    awards: 'Finalist for the 2019 Harriet Tubman Prize'
  }, {
    title: 'CORPORATE FINANCE',
    author: 'Jonathan Berk & Peter DeMarzo',
    year: '2023',
    publisher: 'Kindle Edition',
    cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jjDWMq9LTEQ51esAJhJGT6/s-l1600.webp',
    description: 'The new canon for corporate finance texts.',
    rating: '4.3/5 stars (35 ratings)',
    goodreads: 'Top textbook in Finance',
    awards: 'Leading textbook in corporate finance'
  }];
  // Presentations
  const presentations = [{
    title: 'BIOMIMICRY AS VIOLATION',
    event: 'TED',
    location: 'Vancouver',
    year: '2023',
    image: 'https://images.unsplash.com/photo-1475721027785-f74ec9c409d6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    link: '#'
  }, {
    title: 'DIGITAL INFECTION',
    event: 'SXSW',
    location: 'Austin',
    year: '2022',
    image: 'https://images.unsplash.com/photo-1515187029135-18ee286d815b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    link: '#'
  }, {
    title: 'PUBLIC CONTAMINATION',
    event: 'Design Indaba',
    location: 'Cape Town',
    year: '2022',
    image: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    link: '#'
  }, {
    title: 'BIOLOGICAL BOUNDARIES',
    event: 'Web Summit',
    location: 'Lisbon',
    year: '2021',
    image: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    link: '#'
  }];
  // Press
  const press = [{
    logo: 'https://upload.wikimedia.org/wikipedia/commons/7/77/The_New_York_Times_logo.png',
    name: 'NYT',
    feature: 'Arts & Design',
    quote: 'Confronting our technological future.',
    url: 'https://www.nytimes.com/'
  }, {
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0f/Forbes_logo.svg',
    name: 'Forbes',
    feature: '30 Under 30',
    quote: 'Challenging what constitutes life itself.',
    url: 'https://www.forbes.com/'
  }, {
    logo: 'https://upload.wikimedia.org/wikipedia/commons/9/93/The_Guardian.svg',
    name: 'Guardian',
    feature: 'Future Series',
    quote: 'Visceral discomfort violating natural order.',
    url: 'https://www.theguardian.com/'
  }, {
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0e/The_Wall_Street_Journal_Logo.svg',
    name: 'WSJ',
    feature: 'Innovators',
    quote: 'Organisms in the synthetic-biological uncanny valley.',
    url: 'https://www.wsj.com/'
  }, {
    logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f1/Vanity_Fair_Logo.svg',
    name: 'Vanity Fair',
    feature: 'Art & Design',
    quote: 'Blurring creator and creation disturbingly.',
    url: 'https://www.vanityfair.com/'
  }];
  const renderTabContent = () => {
    switch (activeTab) {
      case 'publications':
        return <div className="grid grid-cols-1 md:grid-cols-3 gap-8 animate-fade-in" data-id="element-1056">
            {publications.map((book, index) => <div key={index} className="glass overflow-hidden group hover:border-[#5ee7df]/50 border border-[#1a2a40]/50 transition-all duration-500 relative rounded-lg" onMouseEnter={() => onCursorChange('image')} onMouseLeave={() => onCursorChange('default')} style={{
            animationDelay: `${index * 100}ms`
          }} data-id="element-1057">
                <div className="aspect-[2/3] overflow-hidden relative" data-id="element-1058">
                  <img src={book.cover} alt={book.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 filter contrast-125 brightness-75 grayscale group-hover:grayscale-0" data-id="element-1059" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#000000] via-[#000000]/70 to-transparent opacity-70" data-id="element-1060"></div>
                  {/* Scan line effect */}
                  <div className="absolute inset-0 bg-[linear-gradient(transparent_50%,rgba(16,22,36,0.2)_50%)] bg-[size:100%_4px] opacity-0 group-hover:opacity-40 transition-opacity duration-500 animate-[scanlines_8s_linear_infinite]" data-id="element-1061"></div>
                  {/* Project Gutenberg style label */}
                  <div className="absolute top-2 left-2 right-2 px-2 py-1 glass text-[#5ee7df] text-xs font-mono uppercase tracking-wider border border-[#5ee7df]/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-1062">
                    FREE EBOOK
                  </div>
                  <div className="absolute bottom-0 left-0 p-4 w-full" data-id="element-1063">
                    <h3 className="text-xl font-bold text-[#e0e6f0] mb-1 font-heading" data-id="element-1064">
                      {book.title}
                    </h3>
                    <p className="text-[#5ee7df] text-sm font-mono" data-id="element-1065">
                      by {book.author} • {book.year}
                    </p>
                  </div>
                </div>
                <div className="p-4" data-id="element-1066">
                  <p className="text-[#8a9cb9] text-sm font-mono mb-2" data-id="element-1067">
                    {book.description}
                  </p>
                  <div className="mt-2 flex flex-col gap-1" data-id="element-1068">
                    <div className="text-[#a0c0e0] text-xs font-mono" data-id="element-1069">
                      {book.rating}
                    </div>
                    <div className="text-[#a0c0e0] text-xs font-mono" data-id="element-1070">
                      {book.goodreads}
                    </div>
                    <div className="text-[#5ee7df] text-xs font-mono mt-1" data-id="element-1071">
                      {book.awards}
                    </div>
                  </div>
                  {/* Project Gutenberg style download section */}
                  <div className="mt-4 pt-3 border-t border-[#1a2a40]/50" data-id="element-1072">
                    <div className="flex flex-wrap gap-2" data-id="element-1073">
                      <span className="px-2 py-1 text-xs border border-[#5ee7df]/30 text-[#5ee7df] font-mono hover:bg-[#5ee7df]/10 transition-colors duration-300 rounded" data-id="element-1074">
                        EPUB
                      </span>
                      <span className="px-2 py-1 text-xs border border-[#5ee7df]/30 text-[#5ee7df] font-mono hover:bg-[#5ee7df]/10 transition-colors duration-300 rounded" data-id="element-1075">
                        KINDLE
                      </span>
                      <span className="px-2 py-1 text-xs border border-[#5ee7df]/30 text-[#5ee7df] font-mono hover:bg-[#5ee7df]/10 transition-colors duration-300 rounded" data-id="element-1076">
                        PDF
                      </span>
                      <span className="px-2 py-1 text-xs border border-[#5ee7df]/30 text-[#5ee7df] font-mono hover:bg-[#5ee7df]/10 transition-colors duration-300 rounded" data-id="element-1077">
                        HTML
                      </span>
                    </div>
                  </div>
                </div>
                {/* Glow effect on hover */}
                <div className="absolute -inset-0.5 bg-gradient-to-br from-[#5ee7df]/30 to-[#2a4d7f]/30 opacity-0 group-hover:opacity-100 blur-sm transition-opacity duration-500 -z-10 rounded-lg" data-id="element-1078"></div>
              </div>)}
          </div>;
      case 'presentations':
        return <div className="grid grid-cols-1 md:grid-cols-2 gap-6 animate-fade-in" data-id="element-1079">
            {presentations.map((talk, index) => <div key={index} className="flex flex-col md:flex-row glass overflow-hidden hover:border-[#5ee7df]/50 border border-[#1a2a40]/50 transition-all duration-500 relative rounded-lg" onMouseEnter={() => onCursorChange('image')} onMouseLeave={() => onCursorChange('default')} style={{
            animationDelay: `${index * 100}ms`
          }} data-id="element-1080">
                <div className="md:w-2/5 h-48 md:h-auto overflow-hidden relative" data-id="element-1081">
                  <img src={talk.image} alt={talk.title} className="w-full h-full object-cover filter contrast-125 brightness-75 grayscale hover:grayscale-0 transition-all duration-700" data-id="element-1082" />
                  {/* Scan line effect */}
                  <div className="absolute inset-0 bg-[linear-gradient(transparent_50%,rgba(16,22,36,0.2)_50%)] bg-[size:100%_4px] opacity-0 hover:opacity-40 transition-opacity duration-500 animate-[scanlines_8s_linear_infinite]" data-id="element-1083"></div>
                </div>
                <div className="md:w-3/5 p-6 flex flex-col justify-between" data-id="element-1084">
                  <div data-id="element-1085">
                    <h3 className="text-xl font-bold text-[#e0e6f0] mb-2 font-heading" data-id="element-1086">
                      {talk.title}
                    </h3>
                    <p className="text-[#5ee7df] mb-4 font-mono" data-id="element-1087">
                      {talk.event} • {talk.location}
                    </p>
                    <span className="inline-block px-3 py-1 text-xs glass text-[#8a9cb9] mb-4 font-mono hover:text-[#5ee7df] transition-colors duration-300 rounded border border-[#1a2a40]/50" data-id="element-1088">
                      {talk.year}
                    </span>
                  </div>
                  <a href={talk.link} className="text-[#8a9cb9] hover:text-[#5ee7df] text-sm font-mono relative group" onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('image')} data-id="element-1089">
                    WITNESS
                    <span className="absolute bottom-0 left-0 h-px w-0 bg-[#5ee7df] group-hover:w-full transition-all duration-300" data-id="element-1090"></span>
                  </a>
                </div>
                {/* Glow effect on hover */}
                <div className="absolute -inset-0.5 bg-gradient-to-br from-[#5ee7df]/30 to-[#2a4d7f]/30 opacity-0 hover:opacity-100 blur-sm transition-opacity duration-500 -z-10 rounded-lg" data-id="element-1091"></div>
              </div>)}
          </div>;
      case 'press':
        return <div className="animate-fade-in" data-id="element-1092">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 mb-12" data-id="element-1093">
              {press.map((item, index) => <a key={index} href={item.url} target="_blank" rel="noopener noreferrer" className="glass hover:border-[#5ee7df]/50 border border-[#1a2a40]/50 transition-all duration-500 p-4 flex items-center justify-center h-24 relative rounded-lg group" onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} style={{
              animationDelay: `${index * 50}ms`
            }} data-id="element-1094">
                  <img src={item.logo} alt={item.name} className="max-h-12 max-w-full filter invert opacity-70 group-hover:opacity-100 transition-opacity duration-500" data-id="element-1095" />
                  {/* Glow effect on hover */}
                  <div className="absolute -inset-0.5 bg-gradient-to-br from-[#5ee7df]/30 to-[#2a4d7f]/30 opacity-0 group-hover:opacity-100 blur-sm transition-opacity duration-500 -z-10 rounded-lg" data-id="element-1096"></div>
                </a>)}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1097">
              {press.map((item, index) => <a key={`quote-${index}`} href={item.url} target="_blank" rel="noopener noreferrer" className="glass hover:border-[#5ee7df]/50 border border-[#1a2a40]/50 transition-all duration-500 p-6 relative rounded-lg group" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} style={{
              animationDelay: `${(index + 6) * 50}ms`
            }} data-id="element-1098">
                  <div className="flex items-center mb-4" data-id="element-1099">
                    <img src={item.logo} alt={item.name} className="h-8 mr-3 filter invert opacity-70" data-id="element-1100" />
                    <div data-id="element-1101">
                      <h3 className="text-lg font-bold text-[#e0e6f0] font-heading" data-id="element-1102">
                        {item.name}
                      </h3>
                      <p className="text-sm text-[#5ee7df] font-mono" data-id="element-1103">
                        {item.feature}
                      </p>
                    </div>
                  </div>
                  <blockquote className="text-[#8a9cb9] border-l-2 border-[#5ee7df] pl-4 italic font-mono" data-id="element-1104">
                    "{item.quote}"
                  </blockquote>
                  {/* Glow effect on hover */}
                  <div className="absolute -inset-0.5 bg-gradient-to-br from-[#5ee7df]/30 to-[#2a4d7f]/30 opacity-0 group-hover:opacity-100 blur-sm transition-opacity duration-500 -z-10 rounded-lg" data-id="element-1105"></div>
                </a>)}
            </div>
          </div>;
      default:
        return null;
    }
  };
  return <section id="media" className="w-full py-24 relative overflow-hidden" data-id="element-1106">
      <style jsx global data-id="element-1107">{`
        @keyframes tab-slide-out {
          0% {
            opacity: 1;
            transform: translateY(0);
          }
          100% {
            opacity: 0;
            transform: translateY(20px);
          }
        }
        .tab-content-changing {
          animation: tab-slide-out 0.3s forwards;
        }
        .animate-fade-in {
          animation: fade-in-up 0.5s forwards;
        }
      `}</style>
      {/* Background effects */}
      <div className="absolute inset-0 bg-[#0a0e17]" data-id="element-1108"></div>
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-30 mix-blend-overlay" data-id="element-1109"></div>
      <div className="absolute inset-0 bg-[url('https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Haeckel_Muscinae.jpg/800px-Haeckel_Muscinae.jpg')] bg-center bg-no-repeat bg-cover opacity-5 mix-blend-color-burn" data-id="element-1110"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-1111">
        <div className="text-center mb-16" data-id="element-1112">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-gradient font-heading animate-fade-in-up" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1113">
            DOCUMENTATION
          </h2>
          <div className="h-px w-20 bg-gradient-to-r from-[#5ee7df] to-[#2a4d7f] mx-auto mb-6 animate-pulse-subtle" data-id="element-1114"></div>
          <p className="text-[#8a9cb9] max-w-2xl mx-auto font-mono animate-fade-in-up" style={{
          animationDelay: '0.2s'
        }} onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1115">
            Records of experiments and reception. Evidence of bio-tech
            corruption.
          </p>
        </div>
        {/* Tab navigation */}
        <div className="flex flex-wrap justify-center mb-12 border-b border-[#1a2a40]/50" data-id="element-1116">
          {[{
          id: 'publications',
          label: 'TEXTS'
        }, {
          id: 'presentations',
          label: 'PRESENTATIONS'
        }, {
          id: 'press',
          label: 'REACTIONS'
        }].map(tab => <button key={tab.id} className={`
                px-6 py-3 uppercase text-sm tracking-wider font-medium transition-all duration-300 font-mono relative group
                ${activeTab === tab.id ? 'text-[#5ee7df] border-b-2 border-[#5ee7df]' : 'text-[#8a9cb9] hover:text-[#e0e6f0]'}
              `} onClick={() => handleTabChange(tab.id)} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} data-id="element-1117">
              {tab.label}
              {activeTab !== tab.id && <span className="absolute bottom-0 left-0 h-px w-0 bg-[#5ee7df] group-hover:w-full transition-all duration-300" data-id="element-1118"></span>}
            </button>)}
        </div>
        {/* Tab content with animation */}
        <div ref={contentRef} className={isTabChanging ? 'tab-content-changing' : ''} data-id="element-1119">
          {!isTabChanging && renderTabContent()}
        </div>
      </div>
    </section>;
};